export default class Showcase {
    static init(): void {
        const stages: NodeListOf<HTMLElement> = document.querySelectorAll('[data-showcase]');

        stages.forEach((stage) => this.stageInit(stage));
    }

    static stageInit(stage: HTMLElement): void {
        const items: HTMLElement[] = Array.from(stage.querySelectorAll('[data-showcase-item]'));

        if (items.length === 0) {
            return;
        }

        const media: HTMLElement[] = Array.from(stage.querySelectorAll('[data-showcase-media]'));

        const activeIndex = () => items.findIndex((item) => item.classList.contains('showcase__item--active'));

        const setActiveMedia = (itemIndex: number, slideIndex: number): void => {
            media.forEach((mediaItem) => {
                const isActive =
                    Number(mediaItem.dataset.index) === itemIndex &&
                    Number(mediaItem.dataset.slideIndex) === slideIndex;
                mediaItem.classList.toggle('showcase__media--active', isActive);
            });
        };

        const setActiveItem = (index: number, resetSlide = true): void => {
            const target = (index + items.length) % items.length;

            items.forEach((item, itemIndex) => {
                const isActive = itemIndex === target;
                item.classList.toggle('showcase__item--active', isActive);

                const toggle: HTMLElement | null = item.querySelector('[data-showcase-toggle]');
                toggle?.setAttribute('aria-expanded', isActive ? 'true' : 'false');

                if (isActive && resetSlide) {
                    this.setActiveSlide(item, 0);
                }
            });

            setActiveMedia(target, resetSlide ? 0 : this.activeSlideIndex(items[target]));
        };

        items.forEach((item, index) => {
            const toggle: HTMLElement | null = item.querySelector('[data-showcase-toggle]');

            toggle?.addEventListener('click', () => {
                if (activeIndex() !== index) {
                    setActiveItem(index);
                }
            });

            const dots: NodeListOf<HTMLElement> = item.querySelectorAll('[data-showcase-dot]');
            dots.forEach((dot, slideIndex) => {
                dot.addEventListener('click', () => {
                    this.setActiveSlide(item, slideIndex);
                    setActiveMedia(index, slideIndex);
                });
            });
        });

        const prev: HTMLElement | null = stage.querySelector('[data-showcase-prev]');
        const next: HTMLElement | null = stage.querySelector('[data-showcase-next]');

        prev?.addEventListener('click', () => setActiveItem(activeIndex() - 1));
        next?.addEventListener('click', () => setActiveItem(activeIndex() + 1));
    }

    static activeSlideIndex(item: HTMLElement): number {
        const slides: HTMLElement[] = Array.from(item.querySelectorAll('[data-showcase-slide]'));
        const index = slides.findIndex((slide) => slide.classList.contains('showcase__slide--active'));

        return index === -1 ? 0 : index;
    }

    static setActiveSlide(item: HTMLElement, slideIndex: number): void {
        const slides: NodeListOf<HTMLElement> = item.querySelectorAll('[data-showcase-slide]');
        const dots: NodeListOf<HTMLElement> = item.querySelectorAll('[data-showcase-dot]');

        slides.forEach((slide, index) => {
            slide.classList.toggle('showcase__slide--active', index === slideIndex);
        });

        dots.forEach((dot, index) => {
            dot.classList.toggle('showcase__dot--active', index === slideIndex);
        });
    }
}
